import { createSlice } from "@reduxjs/toolkit";

const cmsSlice = createSlice({
  name: "cms",
  initialState: {
    data: {},
    status: "idle",
    error: null,
  },
  reducers: {
    setCmsLoading: (state) => {
      state.status = "loading";
      state.error = null;
    },
    setCmsData: (state, action) => {
      state.status = "succeeded";
      state.data = action.payload;
    },
    setCmsError: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    clearCmsData: (state) => {
      state.data = {};
      state.status = "idle";
      state.error = null;
    },
  },
});

export const { setCmsLoading, setCmsData, setCmsError, clearCmsData } =
  cmsSlice.actions;
export default cmsSlice.reducer;
